import React from "react";
import NavBar from "../shared/components/Navbar";
import Footer from "../shared/components/Footer";
import TermsAndConditions from "../dashboard/components/settings/TermAndConditions";

const TermsPage = () => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <NavBar />
    <main className="flex-1 pt-20">
      <TermsAndConditions />
    </main>
    <Footer />
  </div>
);

export default TermsPage;